import { html } from "lit";
import { ActivityHistorySearchResults } from "./activity-history-search-results";
import { translate } from "../../../localization";

export const template = (props: ActivityHistorySearchResults) =>
  html`<div class="search-header">
    ${translate("searchBarResults")} “${props.searchQuery}”
  </div>`;
